"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ResponsiveImage = function ResponsiveImageComponent(_ref) {
  var _ref$sliceData$primar = _ref.sliceData.primary,
      desktop_image = _ref$sliceData$primar.desktop_image,
      mobile_image = _ref$sliceData$primar.mobile_image,
      image_alignment = _ref$sliceData$primar.image_alignment;
  var wrapperClasses = (0, _classnames["default"])({
    'content-page__responsive-image-wrapper': true,
    'content-page__responsive-image-wrapper--left': image_alignment === 'Left',
    'content-page__responsive-image-wrapper--center': image_alignment === 'Center',
    'content-page__responsive-image-wrapper--right': image_alignment === 'Right'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "content-page__responsive-image--mobile",
    src: mobile_image.url,
    alt: mobile_image.alt
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "content-page__responsive-image--desktop",
    src: desktop_image.url,
    alt: desktop_image.alt
  })));
};

ResponsiveImage.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      desktop_image: _propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired,
        alt: _propTypes["default"].string.isRequired
      }).isRequired,
      mobile_image: _propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired,
        alt: _propTypes["default"].string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
var _default = ResponsiveImage;
exports["default"] = _default;